// extracted by mini-css-extract-plugin
export default {"easyContainer":"Easy_easyContainer__69HAz","btn":"Easy_btn__T6CHZ","failed":"Easy_failed__lvOak"};